import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group-container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("ยกเลิก")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, "บันทึกข้อมูล", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonModalWithPreset = _resolveComponent("CommonModalWithPreset")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonForm = _resolveComponent("CommonForm")!
  const _component_PageColumn = _resolveComponent("PageColumn")!

  return (_openBlock(), _createBlock(_component_PageColumn, {
    class: "user-editor",
    paddingMainContents: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CommonModalWithPreset, {
        type: "success-close",
        ref: "confirmModal"
      }, null, 512),
      _createVNode(_component_Panel, {
        class: "mx-auto",
        style: {"max-width":"900px"},
        title: _ctx.$route.params.id ? 'แก้ไขผู้ใช้งาน' : 'เพิ่มผู้ใช้งาน'
      }, {
        float: _withCtx(() => [
          _createVNode(_component_CommonModalWithPreset, {
            ref: "storageLimitModal",
            type: "upload-failed",
            hideClose: ""
          }, null, 512),
          _createVNode(_component_CommonModalWithPreset, {
            ref: "confirmModal",
            type: "success-close",
            onDone: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'SettingUserList' })))
          }, null, 512),
          _createVNode(_component_CommonModalWithPreset, {
            ref: "errorModal",
            type: "failed"
          }, null, 512)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_CommonForm, {
            autocomplete: "on",
            form: _ctx.form
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Panel, {
                    title: "ข้อมูลบัญชีผู้ใช้งาน",
                    subtitle:  _ctx.edit == true ? 'ปล่อยช่อง password ว่าง หากไม่ต้องการเปลี่ยนรหัสผ่าน' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_CommonInput, {
                              modelValue: _ctx.form.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                              label: "Name",
                              placeholder: "ระบุชื่อสำหรับแสดงในระบบ"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_CommonInput, {
                              modelValue: _ctx.form.email,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                              label: "Email",
                              placeholder: "ระบุ Email สำหรับเข้าใช้ระบบ"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_CommonInput, {
                              modelValue: _ctx.form.employeeCode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.employeeCode) = $event)),
                              label: "Employee Code",
                              placeholder: 'โปรดระบุรหัสพนักงาน'
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_CommonInput, {
                              type: "password",
                              modelValue: _ctx.form.password,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                              label: "รหัสผ่าน",
                              placeholder: 'โปรดระบุรหัสผ่าน',
                              autocomplete: "new-password",
                              vid: "password",
                              rules:  _ctx.edit == false ? 'required|min:8' : undefined
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_CommonInput, {
                              type: "password",
                              rules: "confirmed:password|required_if:password|min:8",
                              modelValue: _ctx.form.confirmPassword,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                              autocomplete: "new-password",
                              label: "ยืนยันรหัสผ่าน",
                              placeholder: 'ยืนยันรหัสผ่าน'
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["subtitle"])
                ]),
                _: 1
              }),
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_CommonButton, {
                        class: "mr-3",
                        level: "secondary-blend",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.go(-1)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CommonButton, {
                        level: "primary",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["form"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}